import { CPMMState } from '../enums/cpmm-state.enum';

export class CPMMActivationDetails {
    activationState: CPMMState;
    activationStartDate?: Date;
    updatedBy: string;
}
